import {
  ListItem, ListItemButton, ListItemText,
} from '@mui/material';
import React, { MouseEventHandler } from 'react';
import { Instruction } from '../../hooks/use-form-fields';
import { LinkedRecord } from '../../shared/material_components/linked-cell';
import parseRecordTitle from '../helpers/record-title-parser';
import {RestApiForm} from "../types";

interface Props {
  record: LinkedRecord
  onClick?: (record: LinkedRecord, specialInstructions?: Instruction[]) => void
  restForm: RestApiForm
  disabled?: boolean
  specialInstructions?: Instruction[]
}

const AppItemLink: React.FC<Props> = ({
  record, onClick = () => {}, restForm, disabled, specialInstructions,
}) => {
  const handleClick = (e: MouseEventHandler<HTMLElement>) => {
    // @ts-ignore
    e.preventDefault();

    if (!disabled) {
      onClick(record, specialInstructions);
    }
  };

  const recordTitle = parseRecordTitle(record, restForm);

  return (
    // @ts-ignore
    <ListItem onClick={handleClick} disablePadding>
      <ListItemButton disabled={disabled}>
        <ListItemText primary={recordTitle} />
      </ListItemButton>
    </ListItem>
  );
};

export default AppItemLink;
